import { Selector } from '@reduxjs/toolkit';
import { Functions, UI } from '@taraai/types';
import { RootState } from 'reduxStore/store';

export type AsanaSelector = Selector<RootState, UI.UITask[] | undefined>;
export type TrelloSelector = Selector<RootState, UI.UITask[] | undefined>;

export const selectNotifcation = (service: Functions.ImportCSVFile.CSVImportableService) => (state: RootState) =>
  state.imports.notifications[service];
